(function () {
  /* One definition per popup block. The block id used to be baked into this code by
     Liquid; it now arrives as a parameter, read from the JSON tag the block renders
     next to itself, so the code can live in a cached asset. Two popups on one page
     still get two element names and two sets of cookie keys, which is what the
     baked-in id gave us for free. */
  function hlNewsletterPopup(id) {
    var TAG = 'hl-newsletter-popup-' + id;
    if (customElements.get(TAG)) return;

    var SEEN = 'hl_np_seen_' + id;
    var SUBSCRIBED = 'hl_np_sub_' + id;
    /* Written by onSubmit, one instant before the browser leaves for /contact. It is
       the only signal that survives a round trip that comes back WITHOUT
       customer_posted -- a POST Shopify redirected somewhere else, a tab restored
       after a captcha, a back button. data-posted alone left those shoppers with the
       SEEN cookie already written by open(), so the popup stayed shut and the code
       they had just earned was never shown. */
    var PENDING = 'hl_np_pending_' + id;
    /* The add-to-cart trigger gets its own suppression key. SEEN is about the
       timed popup on a blog page -- a reader who waved that away has said nothing
       about an offer attached to a product they have just put in their cart, and
       collapsing the two would make the new trigger almost unreachable for anyone
       who had ever read an article. SUBSCRIBED still wins over both. */
    var ATC_SEEN = 'hl_np_atc_' + id;
    /* Cart mode (2026-09-25). Survives the /contact round trip in sessionStorage so
       the success step comes back as the cart version (Apply & check out) rather
       than the generic one. */
    var MODE = 'hl_np_mode_' + id;
    var CART_DONE = 'hl_np_cartdone_' + id;
    function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function ssSet(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }

    /* The cart drawer is NOT identifiable by class name. Live markup is
         <dialog class="theme-drawer__dialog color-custom-drawer"
                 aria-labelledby="cart-drawer-heading" cart-summary-sticky>
       -- no "cart" anywhere in className, which is the same trap that has had
       snippets/hl-shop-tracking.js filing every cart-drawer open under the name
       "colour" since August. Match the aria relationship and the component
       attribute, which are what the drawer actually is. */
    var CART_DRAWER = 'dialog[aria-labelledby="cart-drawer-heading"],' +
                      'dialog[cart-summary-sticky],' +
                      'cart-drawer-component dialog,' +
                      'dialog.cart-drawer__dialog';

    /* Controls that put something in the cart. Buy-now is deliberately excluded:
       it leaves for checkout and never opens the drawer, so there is no close to
       react to and nothing to interrupt. */
    var ATC_CONTROL = '[name="add"],.add-to-cart-button,.sticky-add-to-cart__button,' +
                      '.hl-buybar button[data-add],quick-add-component button';
    var LEAVING = '[name="checkout"],.cart__checkout-button,a[href*="/checkouts"],' +
                  'a[href$="/cart"],.shopify-payment-button__button';

    function readCookie(name) {
      return document.cookie.split('; ').some(function (c) { return c.indexOf(name + '=1') === 0; });
    }
    function clearCookie(name) {
      document.cookie = name + '=1; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
    }
    function writeCookie(name, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      document.cookie = name + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }

    /* This theme scrolls an inner container, not the window: html and body are
       overflow:hidden and div.page-wrapper is the element that actually moves, so
       window.scrollY is 0 for the life of the page and window 'scroll' never fires.
       Capture phase on document sees the inner scroller's events; measure whatever
       moved, ignoring small internal scrollers such as a variant row or a drawer. */
    function depthOf(el) {
      if (!el) return 0;
      var h = el.scrollHeight - (el.clientHeight || 0);
      if (h < 400) return 0;
      return (el.scrollTop || 0) / h;
    }

    var Popup = class extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('[data-np-overlay]');
        this.dialog = this.querySelector('[data-np-dialog]');
        this.form = this.querySelector('form');
        this.emailInput = this.querySelector('[data-np-email]');
        this.errorEl = this.querySelector('[data-np-error]');
        this.submitBtn = this.querySelector('[data-np-submit]');
        if (!this.overlay) return;

        this.gate = this.querySelector('[data-np-gate]');
        this.acceptBtn = this.querySelector('[data-np-accept]');

        this.editor = this.dataset.editor === '1';
        this.reshowDays = parseInt(this.dataset.reshowDays, 10) || 7;
        this.scrollAt = (parseInt(this.dataset.scroll, 10) || 50) / 100;
        this.twoStep = this.dataset.twoStep === '1' && !!this.acceptBtn;
        /* Whether this template may open the popup on its own. The block renders
           everywhere now so the add-to-cart trigger can exist on product pages,
           but the owner's rule that it only INTERRUPTS people on /blogs is kept
           by this flag rather than by not rendering. */
        this.passive = this.dataset.passive === '1';
        this.atcOn = this.dataset.atcTrigger === '1';
        this.atcDays = parseInt(this.dataset.atcReshowDays, 10) || 14;

        var params = new URLSearchParams(location.search);
        var forced = params.get('popup') === 'now';
        var forceCart = params.get('popup') === 'cart';
        if (forceCart) forced = true;
        if (params.get('popup') === 'off') return;

        /* Coming back from a submit has to bypass this gate, not be caught by it.
           open() writes the SEEN cookie, so by the time Shopify redirects the shopper
           back here that cookie always exists -- gating on it first meant the success
           state could never be reached and nobody was shown the code they had just
           earned. The SUBSCRIBED cookie has to be bypassed for the same reason: succeed()
           writes it, so a repeat signup would be silently swallowed too. Device targeting
           is skipped as well; someone who just submitted the form self-evidently had it. */
        var posted = this.dataset.posted === '1';
        var rejected = this.dataset.errors === '1';
        var pending = readCookie(PENDING);

        /* Two independent permissions now, because there are two kinds of opening.
           `mayPassive` is the timed/scroll/exit popup and keeps the original rules.
           `mayAtc` is the one that follows a deliberate add to cart, so it answers
           to its own cookie and is allowed on templates where the timed one is not.
           Returning early only when BOTH are refused is the whole point: the old
           single `return` on the SEEN cookie would have silently disabled the new
           trigger for every visitor who had already been shown the blog popup. */
        var devices = this.dataset.devices || 'both';
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var deviceOk = !((devices === 'desktop' && isMobile) || (devices === 'mobile' && !isMobile));
        var returning = posted || pending || rejected;
        var bypass = forced || returning || this.editor;

        var mayPassive = bypass ||
              (this.passive && deviceOk && !readCookie(SUBSCRIBED) && !readCookie(SEEN));
        /* Cart-close offer, 2026-09-26. Owner first asked for it on every close, then the
           same day: "show 1 lần thôi". Once per atc_reshow_days (ATC_SEEN, written by
           open()), never for a subscriber, never for a signed-in customer. */
        var mayAtc = this.atcOn && this.dataset.customer !== '1' && (bypass ||
              (deviceOk && !readCookie(SUBSCRIBED) && !readCookie(ATC_SEEN)));
        if (!mayPassive && !mayAtc) return;
        this.mayPassive = mayPassive;
        this.mayAtc = mayAtc;

        /* The overlay has to be a direct child of <body>. Left where the theme
           renders it -- nested inside the section wrappers -- the Shopify cookie
           consent banner painted OVER it despite the overlay carrying a far higher
           z-index, which on mobile buried the email field and the button under the
           banner. Measured on 390x844: elementFromPoint over the input returned
           #shopify-pc__banner; after moving the overlay to <body> it returns the
           input. Portal it once, on connect. */
        document.body.appendChild(this.overlay);

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.requestOpen = this.requestOpen.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onExitIntent = this.onExitIntent.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.succeed = this.succeed.bind(this);
        this.accept = this.accept.bind(this);
        this.onDialogAttr = this.onDialogAttr.bind(this);
        this.onCartClick = this.onCartClick.bind(this);

        /* Query from this.overlay, NOT from this: connectedCallback has already moved
           the overlay to <body>, so the host element is empty by now. Binding the close
           buttons off the host is what left the X and the No thanks link inert. */
        this.overlay.querySelectorAll('[data-np-close]').forEach(function (b) {
          b.addEventListener('click', this.close);
        }, this);
        this.overlay.addEventListener('click', function (e) {
          /* A tap on the backdrop closes every step (owner, 2026-10-14 — it used to
             close only the finished one). Not while an address is being sent. */
          if (e.target === this.overlay && !this._sending) this.close();
        }.bind(this));
        /* Leaving the page while the offer is up asks first, the browser's own
           "Leave site?" (owner, 2026-10-14). Armed only while the popup is showing
           and not finished, and dropped for the popup's own links (apply code). */
        this.onBeforeUnload = function (e) {
          if (this._letGo || !this.overlay.classList.contains('is-visible') ||
              this.overlay.classList.contains('is-done')) return;
          e.preventDefault();
          e.returnValue = '';
          return '';
        }.bind(this);
        this.overlay.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('a[href]')) this._letGo = true;
        }.bind(this), true);
        var copyBtn = this.overlay.querySelector('[data-np-copy]');
        if (copyBtn) copyBtn.addEventListener('click', this.copyCode.bind(this));
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit);
          if (typeof window.hlNlPrepare === 'function') window.hlNlPrepare(this.form);
        }

        var acceptBtn = this.overlay.querySelector('[data-np-accept]');
        if (acceptBtn) acceptBtn.addEventListener('click', this.accept);
        /* The decline buttons also carry data-np-close, so close() already runs.
           This only adds the reason, which is the number worth having: a shopper
           who reads the offer and refuses it is a different fact from one who
           presses Escape or the X. */
        this.overlay.querySelectorAll('[data-np-decline]').forEach(function (b) {
          b.addEventListener('click', function () {
            try { window.gtag && window.gtag('event', 'popup_decline',
              { content_group: 'popup', step: this.overlay.classList.contains('is-email') ? 'email' : 'gate' }); } catch (e) {}
          }.bind(this));
        }, this);

        /* One step means the email panel IS the popup, so show it from the start
           rather than rendering a gate nobody asked for. */
        if (!this.twoStep) this.overlay.classList.add('is-email');

        this.mode = 'offer';
        try { this.cartCopy = JSON.parse(this.querySelector('[data-np-cart-copy]').textContent); }
        catch (e) { this.cartCopy = null; }
        var backBtn = this.overlay.querySelector('[data-np-back]');
        if (backBtn) backBtn.addEventListener('click', function () {
          this.close();
          var d = document.getElementById('cart-drawer');
          if (d && typeof d.open === 'function') d.open(); else location.href = '/cart';
        }.bind(this));
        if (returning && ssGet(MODE) === 'cart') this.setMode(null);
        if (returning) ssSet(MODE, null);

        /* Shopify redirects back here after a real submit and this block re-renders with
           form.posted_successfully?, surfaced as data-posted.

           Read that for exactly what it is. Measured 2026-08-27: a plain GET of
           /?customer_posted=true -- no POST anywhere -- already renders data-posted="1".
           form.posted_successfully? is driven by that query parameter, so it proves the
           browser came back from /contact, NOT that a Customer row was written. Treat it
           as "the round trip completed", never as "they are subscribed". Confirming the
           subscription needs Shopify Admin > Customers, or an Admin API read (the app
           currently lacks read_customers, so the API cannot answer it either).

           Deliberately NOT stripping customer_posted off the URL: it is the only visible
           evidence that the submit round-tripped at all, and hiding it made this exact
           bug harder to diagnose. */
        /* Rejected first: pending is set on every submit, so a POST Shopify refused
           ("Email is invalid", "Email has already been taken") would otherwise be
           congratulated with a discount code. Show the form back with its error. */
        if (rejected) {
          clearCookie(PENDING);
          /* They are coming back from a submit Shopify refused, so the decision
             in step 1 was made minutes ago. Sending them to the gate again would
             hide the error message that is the only reason this branch exists. */
          this.overlay.classList.add('is-email');
          this.open();
          return;
        }

        if (posted || pending) {
          clearCookie(PENDING);
          this.overlay.classList.add('is-email');
          this.open();
          /* Only a server-verified round trip earns the year-long SUBSCRIBED cookie.
             Coming back on the pending cookie alone means the code is being shown on
             trust, so leave the 7-day SEEN window in charge and ask again later. */
          this.succeed(posted);
          return;
        }

        this.forced = forced;
        if (forceCart) {
          this.prepareCart().then(function () { this.open(); }.bind(this));
          return;
        }
        if (forced) { this.open(); return; }

        if (this.mayAtc) this.armCartWatch();

        if (!this.mayPassive) return;

        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        /* 0 means no timer, 2026-09-26. The old `parseFloat(...) || 10` turned an
           explicit 0 back into 10 seconds, so the timer could not be switched off.
           It had to be: 01-25/09 the timer fired at ~9s on 82% of blog sessions,
           a quarter of those sessions did nothing after it, and it collected no
           email. Scroll depth and exit intent are the triggers that remain. */
        var delay = parseFloat(this.dataset.delay);
        if (isNaN(delay)) delay = 10;
        if (delay > 0) this.timer = setTimeout(this.requestOpen, delay * 1000);

        /* Exit intent is desktop only: a touch device has no cursor to leave the
           viewport, and the pointer media query is the reliable test. Hold it back for
           the first few seconds so a pointer that starts near the top of the window
           does not fire it on load. */
        if (this.dataset.exitIntent === 'true' &&
            window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          setTimeout(function () {
            document.addEventListener('mouseout', this.onExitIntent);
          }.bind(this), 4000);
        }
      }

      /* ---------- add to cart, then close the drawer ----------
         The moment asked for: the shopper has chosen something and dismissed the
         cart, so they are still here and still shopping. Three conditions, all
         required, because any two of them alone describe someone else:

           1. an add-to-cart control was pressed on this page view,
           2. the cart drawer went from open to closed,
           3. that close was not the shopper leaving for checkout.

         Condition 3 is the one that matters most. The checkout button also closes
         the drawer, and opening a discount popup over someone who is mid-navigation
         to checkout is the single worst thing this feature could do. */
      armCartWatch() {
        if (typeof MutationObserver !== 'function') return;

        document.addEventListener('click', this.onCartClick, true);

        /* Observed on document.body with subtree rather than on the dialogs found
           at load: this theme re-renders the cart drawer through the Section
           Rendering API on every cart change, which REPLACES the <dialog> node.
           An observer bound to the original node stops seeing anything the first
           time something is added -- which is exactly the event we are waiting for.
           Filtering to the `open` attribute keeps the callback rare. */
        this._dObs = new MutationObserver(this.onDialogAttr);
        this._dObs.observe(document.body, {
          subtree: true, attributes: true, attributeFilter: ['open']
        });
      }

      onCartClick(e) {
        var t = e.target.closest && e.target.closest(ATC_CONTROL + ',' + LEAVING);
        if (!t) return;
        if (t.matches(LEAVING)) { this._leaving = true; return; }
        if (t.closest('.shopify-payment-button')) return;
        this._atc = true;
      }

      onDialogAttr(records) {
        for (var i = 0; i < records.length; i++) {
          var d = records[i].target;
          if (!d.matches || !d.matches(CART_DRAWER)) continue;
          if (d.hasAttribute('open')) { this._drawerOpen = true; continue; }
          if (!this._drawerOpen) continue;
          this._drawerOpen = false;
          /* Any close with items in the cart, not only one that followed an add on this
             page (owner, 2026-09-26). Leaving for checkout is not "leaving the cart". */
          if (this._leaving || ssGet(CART_DONE) || (!this.editor && readCookie(ATC_SEEN))) continue;
          if (this.overlay.classList.contains('is-visible')) continue;
          this._atc = false;
          this._trigger = 'atc_cart_close';
          this._viaAtc = true;
          /* Let the drawer finish sliding out before another overlay slides in.
             Two dialogs cross-fading over each other reads as a glitch, and the
             drawer's own transition on this theme is 320ms. */
          clearTimeout(this._atcTimer);
          /* Cart mode: read the cart first. prepareCart() resolves false when the
             offer would cost the shopper money (more items than cart_max_items,
             where the automatic tier beats the code) or the cart already carries a
             code — then nothing opens at all. */
          this.prepareCart().then(function (ok) {
            if (ok) this._atcTimer = setTimeout(this.requestOpen, 420);
          }.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.overlay && this.overlay.parentElement === document.body) this.overlay.remove();
        this.disarm();
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onCartClick, true);
        if (this._dObs) this._dObs.disconnect();
        clearTimeout(this._atcTimer);
      }

      /* Stop every trigger at once, so a queued open cannot be re-queued by a
         second trigger while it is waiting on consent. */
      disarm() {
        clearTimeout(this.timer);
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        document.removeEventListener('mouseout', this.onExitIntent);
        /* Deliberately leaves the cart watcher alone. disarm() runs from open(),
           and after the popup is closed again the add-to-cart path is still a
           legitimate reason to come back -- it is gated by its own cookie, which
           open() has by then written. */
      }

      consentBannerVisible() {
        var b = document.querySelector('#shopify-pc__banner');
        if (!b) return false;
        var s = getComputedStyle(b);
        return s.display !== 'none' && s.visibility !== 'hidden' &&
               b.getBoundingClientRect().height > 0;
      }

      /* Two dialogs stacked on a first-time visitor is the worst version of this
         feature, and a first-time visitor is exactly who both of these target. Hold
         the popup back until the shopper has answered the cookie banner, then open. */
      /* Another dialog is up: the blog's product modal, the cart drawer, a zoom.
         The popup landed on top of the product modal 49 times in September, i.e.
         at the one moment a reader was looking at something to buy. */
      otherDialogOpen() {
        var open = document.querySelectorAll('dialog[open]');
        for (var i = 0; i < open.length; i++) {
          if (!this.overlay.contains(open[i])) return true;
        }
        return false;
      }

      requestOpen() {
        if (this._pending || this.overlay.classList.contains('is-visible')) return;
        /* Only the unprompted triggers wait. They stay armed, so the next scroll
           or exit movement after the dialog closes asks again. The add-to-cart
           trigger runs after the drawer has closed and is not held here. */
        if (this._trigger !== 'atc_cart_close' && this.otherDialogOpen()) return;
        if (!this.consentBannerVisible()) { this.open(); return; }
        this._pending = true;
        this.disarm();
        var iv;
        var go = function () {
          if (this.consentBannerVisible()) return;
          clearInterval(iv);
          document.removeEventListener('visitorConsentCollected', go);
          this._pending = false;
          this.open();
        }.bind(this);
        document.addEventListener('visitorConsentCollected', go);
        iv = setInterval(go, 400);
        setTimeout(function () { clearInterval(iv); }, 120000);
      }

      onScroll(e) {
        var el = (e && e.target && e.target !== document) ? e.target : document.scrollingElement;
        if (depthOf(el) >= this.scrollAt) { this._trigger = 'scroll'; this.requestOpen(); }
      }

      onExitIntent(e) {
        if (e.clientY <= 0 && !e.relatedTarget) { this._trigger = 'exit_intent'; this.requestOpen(); }
      }

      onKey(e) {
        if (e.key === 'Escape') { if (!this._sending) this.close(); return; }
        if (e.key !== 'Tab') return;
        var f = this.dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      /* Lock whatever element is actually scrolling rather than body: setting
         overflow:hidden on a body that never scrolled would do nothing here. */
      lockScroll(lock) {
        var scroller = document.querySelector('.page-wrapper') || document.scrollingElement;
        if (!scroller) return;
        if (lock) {
          this._prevOverflow = scroller.style.overflow;
          scroller.style.overflow = 'hidden';
        } else {
          scroller.style.overflow = this._prevOverflow || '';
        }
      }

      open() {
        if (this.overlay.classList.contains('is-visible')) return;
        this.disarm();
        /* Each trigger writes only its own suppression window, so being shown the
           blog popup does not spend the one chance the add-to-cart moment gets,
           and vice versa. */
        if (!this.editor) writeCookie(this._viaAtc ? ATC_SEEN : SEEN,
                                      this._viaAtc ? this.atcDays : this.reshowDays);
        this._lastFocus = document.activeElement;
        this.overlay.classList.add('is-visible');
        this.overlay.setAttribute('aria-hidden', 'false');
        this.lockScroll(true);
        document.addEventListener('keydown', this.onKey);
        this._letGo = false;
        window.addEventListener('beforeunload', this.onBeforeUnload);

        /* Focus follows whichever panel is showing. Sending focus to the email
           field while the gate is up put the keyboard over a dialog with no field
           on it. */
        var onGate = this.twoStep && !this.overlay.classList.contains('is-email') &&
                     !this.overlay.classList.contains('is-done');
        var target = onGate ? (this.acceptBtn || this.overlay.querySelector('[data-np-accept]'))
                            : (this.emailInput || this.overlay.querySelector('[data-np-close]'));
        if (target) target.focus({ preventScroll: true });

        document.dispatchEvent(new CustomEvent('hl:newsletter-popup:open'));
        try{ window.gtag && window.gtag('event','popup_open',{content_group:'popup',
          trigger:this.forced?'forced':(this._trigger||'delay'),
          step: onGate ? 'gate' : 'email'}); }catch(e){}
      }

      /* ---------- step 1 -> step 2 ----------
         The only thing between the yes and the field. Everything else about this
         method is about not lying to the analytics: the autofocus below would
         otherwise fire email_capture_start, which snippets/hl-shop-tracking.js
         binds to `focus` on the address field. That event is supposed to mean a
         hand went to the field, and 46 of 48 of them in September were already
         bots doing something else (see the bot-filter notes). A focus this code
         caused is not intent, so it is marked and the tracker skips it --
         popup_accept, fired here, is the honest version of the same number. */
      accept() {
        if (this.overlay.classList.contains('is-email')) return;
        this.overlay.classList.add('is-email');
        try{ window.gtag && window.gtag('event','popup_accept',{content_group:'popup',
          trigger:this._trigger||'delay'}); }catch(e){}
        if (!this.emailInput) return;
        this.emailInput.setAttribute('data-np-autofocus', '1');
        this.emailInput.focus({ preventScroll: true });
        /* Cleared on a later task, not synchronously: the focus event has to have
           been dispatched and handled before the marker goes away. */
        setTimeout(function () {
          this.emailInput.removeAttribute('data-np-autofocus');
        }.bind(this), 0);
      }

      close() {
        try{ if(this.overlay.classList.contains('is-visible')) window.gtag && window.gtag('event','popup_close',{content_group:'popup', done:this.overlay.classList.contains('is-done')}); }catch(e){}
        this.overlay.classList.remove('is-visible');
        this.overlay.setAttribute('aria-hidden', 'true');
        this.lockScroll(false);
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('beforeunload', this.onBeforeUnload);
        if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus({ preventScroll: true });
      }

      /* Submit, 2026-10-14: Shopify's own customer form and its hCaptcha, posted into a
         hidden iframe (window.hlNlSubmit, snippets/hl-theme-css.liquid) so the page
         never reloads. No preventDefault here: Shopify's captcha listener owns the
         submit, shows its challenge on this page when it needs one, then submits into
         the iframe. The button holds a progress state until the iframe has Shopify's
         answer, and the success step is shown only for customer_posted=true.

         Before this, the code was revealed 6s after the click whatever happened, and
         the inline newsletter script reset the field under the captcha -- shoppers saw
         "You're in" and no Customer was written (1 popup signup 30/08-14/10). */
      onSubmit(e) {
        if (this._sending) { e.preventDefault(); return; }
        if (!this.form.checkValidity()) { e.preventDefault(); this.form.reportValidity(); return; }
        if (typeof window.hlNlSubmit !== 'function') return;          // plain POST, page reloads
        var tagsEl = this.form.querySelector('[name="contact[tags]"]');
        if (tagsEl && this.mode === 'cart' && tagsEl.value.indexOf('cart offer') < 0) tagsEl.value += ', cart offer';

        this.setSending(true);
        if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
        try{ window.gtag && window.gtag('event','popup_submit',{content_group:'popup', mode:this.mode}); }catch(e){}

        var self = this;
        window.hlNlSubmit(this.form).then(function (r) {
          if (r.ok) {
            /* Hold the full bar for a beat so the finish is seen, then swap steps. */
            self.setSending(false, true);
            self._sending = true;
            setTimeout(function () {
              self._sending = false;
              self.form.classList.remove('is-sent');
              self.succeed(true);
            }, 320);
            return;
          }
          self.setSending(false);
          if (r.idle) return;
          if (self.errorEl) { self.errorEl.textContent = r.error; self.errorEl.hidden = false; }
          try{ window.gtag && window.gtag('event','popup_submit_error',{content_group:'popup', mode:self.mode}); }catch(e){}
        });
      }

      /* The progress state: the form is .is-sending (CSS draws the bar and spinner),
         the field and button are locked, and the backdrop / Escape will not close the
         popup mid-request. `done` lets the bar run to its end before the step swaps. */
      setSending(on, done) {
        this._sending = !!on;
        this.form.classList.toggle('is-sending', !!on);
        this.form.classList.toggle('is-sent', !!done);
        this.submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      }

      succeed(persist) {
        if (!this.editor && persist !== false) writeCookie(SUBSCRIBED, 365);
        if (this.mode === 'cart') ssSet(CART_DONE, '1');
        this.overlay.classList.add('is-done');
        var h = this.overlay.querySelector('[data-np-success] .hl-np-' + id + '__heading');
        if (h) {
          h.setAttribute('tabindex', '-1');
          h.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('hl:newsletter-popup:subscribe'));
        try{ window.gtag && window.gtag('event','popup_subscribe',{content_group:'popup', code:this.dataset.code||'', verified:persist!==false, mode:this.mode}); }catch(e){}
      }

      /* Fetches the cart and, when the offer is worth making, switches the popup to
         cart copy with the first item priced at the code. Resolves true/false. */
      prepareCart() {
        var self = this;
        /* No item cap any more: since 2026-09-26 the code is an ORDER discount that
           stacks on the Buy 2/3/4 tiers (product discounts), so it lowers every cart. */
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart || cart.item_count < 1) return false;
            if ((cart.cart_level_discount_applications || []).some(function (a) { return a.type === 'discount_code'; })) return false;
            self.setMode(cart);
            return true;
          })
          .catch(function () { return false; });
      }

      money(cents, cur) {
        try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
        catch (e) { return '$' + (cents / 100).toFixed(2); }
      }

      setMode(cart) {
        var c = this.cartCopy;
        if (!c) return;
        this.mode = 'cart';
        this.overlay.querySelectorAll('[data-np-t]').forEach(function (el) {
          var v = c[el.getAttribute('data-np-t')];
          if (v) { el.textContent = v; el.hidden = false; }
        });
        /* data-code is blank on blog pages (the Journal invitation shows no code);
           cart mode uses the store code wherever it opens, blog buy bar included. */
        var code = this.dataset.cartCode || this.dataset.code;
        var cta = this.overlay.querySelector('[data-np-cta]');
        if (cta && code) { cta.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'; cta.hidden = false; }
        var jcta = this.overlay.querySelector('[data-np-journal-cta]');
        if (jcta) jcta.hidden = true;
        var codeBox = this.overlay.querySelector('[data-np-code-box]');
        if (codeBox && code) codeBox.hidden = false;
        var back = this.overlay.querySelector('[data-np-back]');
        if (back) back.hidden = false;
        var box = this.overlay.querySelector('[data-np-cart]');
        if (!box || !cart || !cart.items || !cart.items.length) return;
        var pct = parseFloat(c.percent) || 13;
        /* The code replaces the automatic tier rather than stacking on it, so the
           price with the code is the ORIGINAL total less the code, compared with
           what the cart costs now (which may already carry Buy 2 = 10%). */
        /* The code is an order discount that stacks on whatever tier the cart is on,
           so the price with it is TODAY'S total less the code (measured 26/09: 2 units
           $90.00 -> $78.30). */
        var now = cart.total_price;
        var withCode = now - Math.floor(now * pct / 100);   // Shopify rounds the discount down (measured: $265.84 -> $231.29)
        if (withCode >= now) return;
        var P = 'hl-np-' + id + '__';
        var lines = cart.items;
        var thumb = function (it) { return it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; };
        var imgs = lines.slice(0, 3).filter(function (it) { return thumb(it); }).map(function (it) {
          return '<img alt="" width="58" height="58" loading="eager" src="' + thumb(it) + '">';
        }).join('');
        var extra = lines.length > 3 ? '<span class="' + P + 'more">+' + (lines.length - 3) + '</span>' : '';
        var LIST = 2;                                   // names shown; the rest become "+N more"
        var items = lines.slice(0, LIST).map(function () { return '<li></li>'; }).join('') +
          (lines.length > LIST ? '<li class="is-more">+ ' + (lines.length - LIST) + ' more</li>' : '');
        box.innerHTML =
          '<div class="' + P + 'stack' + (Math.min(lines.length, 3) === 1 ? ' ' + P + 'stack--1' : '') + '">' + imgs + extra + '</div>' +
          '<div><ul class="' + P + 'list">' + items + '</ul>' +
          '<p class="' + P + 'cart-p"><s>' + this.money(now, cart.currency) + '</s><b>' + this.money(withCode, cart.currency) +
          '</b><em>\u2212' + pct + '%</em></p></div>';
        var lis = box.querySelectorAll('.' + P + 'list li:not(.is-more)');
        lines.slice(0, LIST).forEach(function (it, i) {
          lis[i].textContent = it.product_title;
          if (it.quantity > 1) { var q = document.createElement('span'); q.textContent = ' \u00d7' + it.quantity; lis[i].appendChild(q); }
        });
        box.hidden = false;
      }

      copyCode() {
        var el = this.overlay.querySelector('[data-np-code-value]');
        var btn = this.overlay.querySelector('[data-np-copy]');
        if (!el || !navigator.clipboard) return;
        navigator.clipboard.writeText(el.textContent.trim()).then(function () {
          btn.textContent = 'Copied';
          setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
        });
      }
    };
    customElements.define(TAG, Popup);
  }

  [].forEach.call(document.querySelectorAll('script[data-hl-newsletter-popup]'), function (node) {
    var id;
    try { id = JSON.parse(node.textContent).id; } catch (e) { return; }
    if (id) hlNewsletterPopup(id);
  });
})();
